<template>
    <div>
        <ul>
            <li v-for="(field, index) in fields">
                <div class="form-row mb-2">
                    <div class="col">
                        <input
                            v-model="field.title"
                            :name="`${prefix}[${index}][title]`"
                            class="form-control"
                            type="text"
                            placeholder="e.g. description, content etc."
                            required
                        >
                    </div>

                    <div class="col">
                        <select
                            v-model="field.type"
                            :name="`${prefix}[${index}][type]`"
                            class="custom-select"
                        >
                            <option value="input">input</option>
                            <option value="text">text</option>
                            <option value="select">select</option>
                            <option value="rich-editor">rich-editor</option>
                            <option value="date">date</option>
                        </select>
                    </div>

                    <div class="col">
                        <input
                            v-model="field.validationRules"
                            :name="`${prefix}[${index}][validationRules]`"
                            class="form-control"
                            type="text"
                            required
                        >
                    </div>

                    <div class="col">
                        <button class="btn btn-danger" @click="removeField(index)" type="button">
                            Verwijder
                        </button>
                    </div>
                </div>
            </li>
        </ul>

        <div class="form-group">
            <button class="btn btn-secondary" @click="addField" type="button">
                Veld toevoegen
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['props'],

    data() {
        return {
            prefix: this.props.prefix,
            prefilledFields: this.props.prefilledFields,
            fields: [],
        };
    },

    created() {
        if (typeof this.prefilledFields !== 'undefined') {
            this.prefilledFields.split(',').forEach((title) => {
                this.fields.push({
                    title,
                    type: 'input',
                    validationRules: 'required',
                });
            });
        }
    },

    methods: {
        addField() {
            this.fields.push({
                title: '',
                type: 'input',
                validationRules: 'required',
            });
        },

        removeField(index) {
            this.$delete(this.fields, index);
        },
    },
};
</script>

<style scoped>
    ul {
        list-style: none;
        padding: 0;
    }
</style>
